var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaleFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 1271 367",
    width: "1271pt",
    height: "367pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_kQNWJUmo9efoaSDe4dplVA0aLw42IS2k"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1271,
    height: 367
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_kQNWJUmo9efoaSDe4dplVA0aLw42IS2k)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: " M 0 167.143 C 84.903 146.12 254.708 60.617 424.514 62.029 C 594.32 63.44 679.731 186.606 849.028 174.2 C 1018.325 161.794 1186.606 34.84 1271 0 L 1271 273 L 0 273 L 0 167.143 Z ",
    fill: "rgb(0,100,244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 1271 167.143 C 1186.097 146.12 1016.292 60.617 846.486 62.029 C 676.68 63.44 591.269 186.606 421.972 174.2 C 252.675 161.794 84.394 34.84 0 0 L 0 273 L 1271 273 L 1271 167.143 Z ",
    fill: "rgb(249,70,57)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 254,
    width: 1271,
    height: 113,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(249,70,57)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaleFooter);
export default __webpack_public_path__ + "static/media/sale_footer.655b2367235086d60117abc394c9bed6.svg";
export { ForwardRef as ReactComponent };